<title>{{ ndcOrderManagementCapabilitiesPage.htmlTitle }}</title>
<app-banner [banner]="ndcOrderManagementCapabilitiesPage.banner" [isCommonBanner]="true"
  [isDefaultPageBanner]="false"></app-banner>

<div class="container mt-3">
  <h5>
    <span style="color: #2980b9">
      <a [href]="OfferManagementLink"> {{ OfferManagementTitle }} </a> {{ linkTextSeperator }} <a
        [href]="OrderManagementLink"> {{ OrderManagementTitle }} </a>
    </span>
  </h5>
  <!-- Nav tabs -->
  <div class="mt-20 managementTab mb-5">
    <ul class="nav nav-tabs">
      <li class="tab-link bgdgry" *ngFor="let link of tabMenu.links; let i = index" class="tab-link bgdgry"
        [ngClass]="selectedIndex === i ? 'border-blue' : 'border-darkblack'">
        <a class="nav-link" data-bs-toggle="tab" href="#{{ link.href }}" (click)="selectedIndex = i">
          <i [ngClass]="link.class || ''"></i>
          <span class="hideme"> {{ link.title }}</span>
        </a>
      </li>
    </ul>

    <!-- Tab panes -->
    <div class="tab-content">
      <div id="{{ link.href }}" *ngFor="let link of tabMenu.links; let i = index" class="tab-pane fade"
        [ngClass]="i === selectedIndex ? 'show active container' : 'container'">
        <br />
        <app-section [sections]="sectionsMap.get(link.title)" [isNDCManagement]="true"> </app-section>
      </div>
    </div>
  </div>
</div>